import type { MultiSelectPassThroughOptions } from "primevue/multiselect";

export const multiselect: MultiSelectPassThroughOptions = {
  root: ({ props }) => ({
    class: [
      `inline-flex cursor-pointer relative select-none rounded-md
        bg-surface-0 dark:bg-surface-950 border
        shadow-[0_1px_2px_0_rgba(18,18,23,0.05)]
        transition-colors duration-200 w-full h-8 pl-3`,
      {
        "hover:dark:border-surface-600": !props.disabled,
        "focus:border-primary": !props.disabled,
        "dark:border-surface-600": !props.disabled,
        "bg-surface-50 dark:bg-surface-800": props.variant === "filled",
        "!border-red-400 !dark:border-red-300": props.invalid,
        "bg-surface-200 text-surface-500 dark:bg-surface-700 dark:text-surface-400 opacity-100 cursor-default":
          props.disabled,
        flex: props.fluid
      }
    ]
  }),
  dropdown: () => ({
    class: [
      `flex items-center justify-center shrink-0 bg-transparent
        text-surface-500 dark:text-surface-400 w-10 rounded-e-md`
    ]
  }),
  labelContainer: () => ({
    class: [`overflow-hidden flex-auto flex items-center`]
  }),
  label: ({ props }) => ({
    class: [
      `flex items-center gap-1 whitespace-nowrap overflow-hidden text-ellipsis  text-surface-700 dark:text-surface-0`,
      {
        "text-surface-500 dark:text-surface-400": props.disabled
      }
    ]
  }),
  overlay: () => ({
    class: [
      `min-w-full absolute top-0 left-0 rounded-md
        bg-surface-0 dark:bg-surface-900
        border border-surface-200 dark:border-surface-700
        text-surface-700 dark:text-surface-0
        shadow-[0_4px_6px_-1px_rgba(0,0,0,0.1),0_2px_4px_-2px_rgba(0,0,0,0.1)]`
    ]
  }),
  header: () => ({
    class: [`flex items-center pt-2 pb-1 px-4`]
  }),
  pcHeaderCheckbox: {
    root: () => ({
      class: [`me-2`]
    })
  },
  pcFilterContainer: {
    root: () => ({
      class: [`flex-auto`]
    })
  },
  pcFilter: {
    root: () => ({
      class: [`w-full`]
    })
  },
  listContainer: () => ({
    class: [`overflow-auto`]
  }),
  list: () => ({
    class: [`m-0 p-1 list-none gap-[2px] flex flex-col`]
  }),
  option: ({ props }) => ({
    class: [
      `cursor-pointer font-normal whitespace-nowrap relative overflow-hidden flex items-center gap-2 px-3 py-2
        rounded-sm text-surface-700 dark:text-surface-0 bg-transparent border-none
        transition-colors duration-200`,
      {
        "focus:!bg-surface-100 focus:dark:bg-surface-800 focus:!text-surface-600 focus:dark:text-surface-0":
          !props
      }
    ]
  }),
  optionGroup: () => ({
    class: [
      `m-0 px-3 py-2 bg-transparent text-surface-500 dark:text-surface-400 font-semibold`
    ]
  }),
  pcChip: {
    root: () => ({
      class: [`flex items-center gap-2 py-1 rounded-sm`]
    })
  }
};
